"use client";
import { jsx as a } from "react/jsx-runtime";
import { memo as l } from "react";
import c from "../components/Icon/SvgIcon.js";
const e = (o) => /* @__PURE__ */ a(
  c,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.25 8.625A2.377 2.377 0 0 1 5.625 6.25h12.75a2.377 2.377 0 0 1 2.375 2.375v6.74a2.377 2.377 0 0 1-2.375 2.375H5.625a2.377 2.377 0 0 1-2.375-2.375zM5.625 18.99h12.75A3.63 3.63 0 0 0 22 15.365v-6.74A3.63 3.63 0 0 0 18.375 5H5.625A3.63 3.63 0 0 0 2 8.625v6.74a3.63 3.63 0 0 0 3.625 3.625m7.379-4.903a1 1 0 0 0 .257-.265.67.67 0 0 0 .102-.37q0-.35-.248-.526c-.141-.099-.374-.19-.687-.276v1.647l.063-.01a1.3 1.3 0 0 0 .513-.199m-2.011-3.147c.11.084.282.155.505.213V9.77h-.003l-.003.001v-.03q-.075.01-.148.03a.9.9 0 0 0-.294.14.7.7 0 0 0-.206.231.7.7 0 0 0-.076.327.54.54 0 0 0 .214.458l.002.001.004.006zm2.945.931q.404.264.595.55.192.287.228.573.035.286.035.511a1.5 1.5 0 0 1-.111.496q-.11.3-.4.587a2.7 2.7 0 0 1-.771.51c-.288.133-.653.215-1.086.254v.72a.195.195 0 0 1-.194.195h-.547a.195.195 0 0 1-.195-.195v-.728c-.663-.069-1.195-.262-1.583-.595q-.554-.477-.702-1.34a.23.23 0 0 1 .229-.263h.965c.11 0 .19.087.204.197a.96.96 0 0 0 .295.61q.248.232.592.331v-1.878l-.03-.007-.108-.023a9 9 0 0 1-.738-.21 2.5 2.5 0 0 1-.651-.323 1.54 1.54 0 0 1-.46-.5q-.17-.3-.171-.749 0-.456.198-.805.195-.35.519-.586.323-.237.747-.367c.225-.07.457-.11.694-.135v-.784c0-.107.087-.195.195-.195h.547c.107 0 .194.088.194.195v.786c.244.032.479.08.697.15q.4.13.7.36.306.226.497.567.144.256.197.585c.018.117-.08.221-.197.221H13.29a.2.2 0 0 1-.196-.156.87.87 0 0 0-.236-.453.8.8 0 0 0-.43-.236v1.606q.164.032.359.08.747.18 1.15.444",
        clipRule: "evenodd"
      }
    )
  }
), m = l(e);
export {
  m as ShopCardBalance,
  m as default
};
